<script lang="ts" setup>
import { useArticleFont } from "@/common/composables/use-article-font.composable";
import type { Explanation } from "@/components/article/arabic/article";

defineProps<{
  explanations: Explanation[];
}>();

const { arabicArticleFontClass } = useArticleFont();
</script>

<template>
  <span class="article-content__text article-content__text--secondary">
    <template v-for="(explanation, index) in explanations" :key="index">
      <span v-if="explanation.prefix" lang="da">{{ explanation.prefix }}</span
      ><span :class="arabicArticleFontClass" lang="ar" dir="rtl">{{ explanation.text }}</span
      >{{ index + 1 < explanations.length ? ", " : "" }}
    </template>
  </span>
</template>
